<template>
    <div class="page-wrapper">
        <div class="page">
            <ul class="page-nav">
                <li><router-link to="/layout/index">首页</router-link></li>
                <!-- <li><a class="a_disabled">协会工作部</a></li> -->
                <li><router-link :to="titleLink">{{ title }}</router-link></li>
                <li class="currentNode"><a>人员分工</a></li>
            </ul>
            <div class="page-main">
                <ul class="vertical-nav">
                    <li class="rootMenu"><a>{{ title }}</a></li>
                    <li><router-link :to="`/layout/info-branch-introduction?id=${id}`">工作部简介</router-link></li>
                    <li><router-link :to="`/layout/info-branch-responsibilities?id=${id}`">主要职责</router-link></li>

                </ul>
                <div class="page-content">
                    <h3>人员分工</h3>
                    <div v-for="people in peopleList" :key="people.Id">
                        <p class="group_title">
                        <span>{{ people.Rank }}</span>
                        </p>
                        <div class="person-instruction">
                            <img :src="people.Picture" />
                            <div class="person-detail">
                                <p class="person-name">{{ people.Name }}</p>
                                <p class="person-sub" v-html="people.Introduction"></p>
                            </div>
                        </div>
                    </div>
                    <!-- <p class="group_title">
                        <span>常务副会长</span>
                    </p>
                    <div class="person-instruction">
                        <img src="@/assets/image/info/zhaokai.png" />
                        <div class="person-detail">
                            <p class="person-name">赵凯</p>
                            <p class="person-sub">赵凯，男，1968年生，高级工程师，北京大学光华管理学院MBA。现任中国循环经济协会常务副会长、民政部全国性社会组织评估专家、民盟北京市委人口资源环境委员会副主任、北京市西城区政协委员、国家绿色发展基金专家咨询委员会专家、全国环保产业标准化技术委员会（SAC/TC275）委员、全国产品回收利用基础与管理标准化技术委员会</p>
                        </div>
                    </div>
                    <p class="group_title">
                        <span>秘书长</span>
                    </p>
                    <div class="person-instruction">
                        <img src="@/assets/image/info/guozhanqiang.png" />
                        <div class="person-detail">
                            <p class="person-name">郭占强</p>
                            <p class="person-sub">郭占强，1982年生，男，中共党员，现任中国循环经济协会秘书长。长期从事循环经济相关政策研究与产业咨询工作，“十二五”以来，承担主管部门委托的多项重大课题研究，为国家颁布循环经济相关规划、制修定相关政策提供决策支撑。主编、参编《中国循环经济发展报告》等多部著作。</p>
                        </div>
                    </div> -->
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {
    getXiehuiExport,
} from '@services/indexService.js'
export default {
    name:'',
    data() {
        return {
            id: '', // 信息工作部1，双招双引工作部2，医疗卫生工作部3，企业工作部4
            title: '',
            peopleList: [],
            titleLink: '',
        }
    },
    created() {
        this.id = this.$route.query.id;
        this.getXiehuiExport();
        this.traverseTitle();
    },
    methods: {
        handleCurrentChange(pageNum) {

        },
        traverseTitle() {
            if (this.id === '1'){
                this.title = "信息工作部";
                this.titleLink = '/layout/info-branch-introduction?id=1';
            } else if (this.id === '2'){
                this.title = "双招双引工作部";
                this.titleLink = '/layout/info-branch-introduction?id=2';
            } else if (this.id === '3') {
                this.title = "医药卫生工作部";
                this.titleLink = '/layout/info-branch-introduction?id=3';
            } else {
                this.title = "企业工作部";
                this.titleLink = '/layout/info-branch-introduction?id=4';
            }
        },
        getXiehuiExport() {
            let params = {
                id: this.id
            };
            getXiehuiExport(params).then(res => {
                console.log(res);
                if (res.Code == 1) {
                    this.peopleList = res.Data;
                } else {
                    this.peopleList = [];
                    this.$message.error("人员分工请求失败");
                }
            })
        }
    },
    watch: {
        // 监听路由对象中的变化
        '$route': {
            handler: function(to, from) {
                // 当路由发生变化时会调用这个函数
                // to 和 from 分别代表到达的路由和离开的路由
                this.id = to.query.id + '';
                this.getXiehuiExport();
                this.traverseTitle();
            },
            // 如果需要在路由变化时立即响应，可以设置immediate为true
            immediate: true
        },
        '$route.query.id': {
            handler: function(toId, fromId){
                this.id = toId;
                this.getXiehuiExport();
                this.traverseTitle();
            },
            // 如果需要在路由变化时立即响应，可以设置immediate为true
            immediate: true
        },
    }
}
</script>

<style scoped>
.page-content {
    padding: 30px;
}
.page-content h3{
    text-align:center;
}
.page-content p {
    font-family: 思源黑体 CN;
    font-size: 16px;
    line-height: 28.64px;
    color: #4E5969;
    margin-bottom: 20px;
    width: 100%;
}
.association-list {
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.association-item {
    width: 216px;
    height: 116px;
    background: #F3F3F3;
    color: #4E5969;
    font-size: 20px;
    text-align:center;
}
.page-content .introduction-title{
    color: #116EBA;
    font-size: 16px;
    font-weight: bold;
    margin-bottom: 5px;
}
.person-instruction {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
}
.person-instruction  img {
    width: 100px;
    height: 128px;
}
.person-detail {
    width: 812px;
}
.page-content .person-name {
    color: #262626;
    font-size: 18px;
    margin-bottom: 10px;
}
.page-content .person-sub{
    color: #86909C;
    font-size: 14px;
    line-height: 20px;
    margin-bottom:0;
}
.a_disabled {
    cursor: not-allowed;
}
</style>